import { AppShell, Flex, Title, ButtonGroup, Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Support } from './Support';

export function PublicSupportPage() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng).catch(() => {
      // Error changing language
    });
  };

  return (
    <AppShell header={{ height: 60 }} padding='md'>
      <AppShell.Header p={'sm'}>
        <Flex align={'center'} justify={'space-between'} style={{ height: 40 }}>
          <Title
            order={4}
            style={{ cursor: 'pointer' }}
            onClick={() => navigate('/login')}
          >
            BECOME.
          </Title>
          <Flex gap='md' align='center'>
            <ButtonGroup>
              <Button
                variant={'subtle'}
                onClick={() => changeLanguage('en')}
                disabled={i18n.language === 'en'}
              >
                English
              </Button>
              <Button
                variant={'subtle'}
                onClick={() => changeLanguage('it')}
                disabled={i18n.language === 'it'}
              >
                Italiano
              </Button>
              <Button
                variant={'subtle'}
                onClick={() => changeLanguage('pt')}
                disabled={i18n.language === 'pt'}
              >
                Português
              </Button>
            </ButtonGroup>
            <Button variant='filled' onClick={() => navigate('/login')}>
              Login
            </Button>
          </Flex>
        </Flex>
      </AppShell.Header>

      <AppShell.Main>
        <Support />
      </AppShell.Main>
    </AppShell>
  );
}
